<ng-progress #progressBar [spinner]="false"></ng-progress>
<div [cgBusy]="busy" [cgBusyConfig]="{message: 'Wird geladen...', backdrop: false, delay: 200, minDuration: 600}"></div>
<!-- <div [ngStyle]="{'height': authService.isAuthenticated() ? '112vh' : '100vh' }"> -->
<div>
    <mat-toolbar *ngIf="authService.isAuthenticated()" class="nepraunik-header nepraunik-color" color="primary">
        <object data="assets/images/nepraunik_logo.svg" type="image/svg+xml" style="height: 52px;width: 100%;">
            <h2 class="logo">
                <span>Nepraunik &amp; Prammer</span>
            </h2>
        </object>
        <span class="fill-remaining-space"></span>

        <nepraunik-logout></nepraunik-logout>
    </mat-toolbar>

    <!-- <mat-sidenav-container class="nepraunik-container"> -->

    <!-- <mat-sidenav *ngIf="authService.isAuthenticated()" #sidenav mode="side" opened="true" class="nepraunik-sidenav" fixedInViewport="false"
            fixedTopGap="0" fixedBottomGap="0">
            <mat-nav-list color="primary">
                <a mat-list-item [routerLink]="['/interesse']">
                    <mat-icon>business</mat-icon>&nbsp;&nbsp; Meine Interesse</a>
            </mat-nav-list>
        </mat-sidenav> -->

    <!-- <mat-sidenav-content> -->
    <router-outlet></router-outlet>
    <!-- </mat-sidenav-content> -->

    <!-- </mat-sidenav-container> -->

    <!-- <mat-toolbar *ngIf="authService.isAuthenticated()" class="nepraunik-footer nepraunik-color" color="primary">
        <span class="fill-remaining-space"></span>
        <section class="mat-body-1">
            <span style="color:rgba(0, 0, 0, 0.87)">© Copyright 2018 | ace Neue Informationstechnologien GmbH</span>
        </section>
    </mat-toolbar> -->

    <simple-notifications [options]="options"></simple-notifications>
</div>


// WEBPACK FOOTER //
// ./src/app/app.component.html